import { useEffect, useState } from "react";
import Actions from "../Actions/Actions";
import Card from "../Card/Card";
import "./Deck.css";

const Deck = ({
  isReversedCardsEnabled,
  onCardRevealed,
  excludedCardNames,
}: {
  isReversedCardsEnabled: boolean;
  onCardRevealed?: (cardName: string, isReversed: boolean) => void;
  excludedCardNames?: string[];
}) => {
  const [hasAddedNewCard, setHasAddedNewCard] = useState(true);
  const [isTouched, setIsTouched] = useState(false);

  useEffect(() => {
    if (hasAddedNewCard) setHasAddedNewCard(false);
  }, [hasAddedNewCard]);

  const handleIsTouchedClick = () => {
    if (!isTouched) setIsTouched(true);
  };

  return (
    <>
      {!hasAddedNewCard ? (
        <div className="Deck-card-center">
          <Card
            handleIsTouchedClick={handleIsTouchedClick}
            isReversedCardsEnabled={isReversedCardsEnabled}
            onCardRevealed={onCardRevealed}
            excludedCardNames={excludedCardNames}
          />
        </div>
      ) : (
        <div className="Deck-placeholder"></div>
      )}
      {/* Show Actions only when no onCardRevealed handler (legacy standalone mode) */}
      {isTouched && !onCardRevealed && (
        <Actions
          actionsNewCardClick={() =>
            setHasAddedNewCard((prevState: boolean) => !prevState)
          }
        />
      )}
    </>
  );
};

export default Deck;
